/**
 * Parse server UTC ISO timestamps for display in the admin UI.
 */
export function parseUtcTimestamp(value) {
  if (!value) return null
  if (value instanceof Date) return value
  const text = String(value).trim()
  if (!text) return null
  const normalized = /([zZ]|[+-]\d{2}:\d{2})$/.test(text) ? text : `${text}Z`
  const parsed = Date.parse(normalized)
  return Number.isNaN(parsed) ? null : new Date(parsed)
}

export function formatUtcTimestamp(value, locale = undefined) {
  const date = parseUtcTimestamp(value)
  return date ? date.toLocaleString(locale) : '—'
}

export function formatUtcTimeAgo(value) {
  const date = parseUtcTimestamp(value)
  if (!date) return '—'
  const diffMs = Date.now() - date.getTime()
  if (diffMs < 0) return 'just now'
  const seconds = Math.floor(diffMs / 1000)
  if (seconds < 60) return `${seconds}s ago`
  const minutes = Math.floor(seconds / 60)
  if (minutes < 60) return `${minutes}m ago`
  const hours = Math.floor(minutes / 60)
  if (hours < 48) return `${hours}h ago`
  const days = Math.floor(hours / 24)
  return `${days}d ago`
}
